// path conversion | funnel
export const CONVERSION_FROM_FIRST = 'conversion_from_first';
export const CONVERSION_FROM_PREVIOUS = 'conversion_from_previous';
export const APP_ID = 'app_id';
